import { extractMessageContent } from './messageContent';

const PLACEHOLDER_USER_PROMPT_MARKERS = [
  'enter your prompt user message here',
  'enter your prompt user message here...',
];

export function normalizePromptUserTemplate(raw) {
  const t = String(raw || '').trim();
  if (!t) return '';
  const lower = t.toLowerCase();
  if (PLACEHOLDER_USER_PROMPT_MARKERS.some((m) => lower === m || lower.startsWith(m))) return '';
  return t;
}

/** Content to send when a workflow button is clicked (template, composer, or recent chat). */
export function pickWorkflowSendContent({ promptTemplate, composerText, messages }) {
  const fromTemplate = normalizePromptUserTemplate(promptTemplate);
  if (fromTemplate) return fromTemplate;
  const fromComposer = String(composerText || '').trim();
  if (fromComposer) return fromComposer;
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    const m = messages[i];
    if (m?.metadata?.visible === false) continue;
    const c = extractMessageContent(m).trim();
    if (c.length < 40) continue;
    if (m.is_agent) {
      return 'Please run this workflow using the relevant information already in the conversation above.';
    }
    return c;
  }
  return '';
}

export function workflowNeedsContentMessage(prompt) {
  const label = prompt?.name || 'This workflow';
  return (
    `${label} needs more content. Paste or type the required input in this box `
    + '(for example, the scored account output from the previous step), then click the workflow button again.'
  );
}

function collectPromptToolIds(prompt) {
  const toolsBlob = prompt?.tools;
  if (Array.isArray(toolsBlob)) {
    return toolsBlob.filter((x) => typeof x === 'string');
  }
  if (toolsBlob && typeof toolsBlob === 'object') {
    return Object.keys(toolsBlob);
  }
  return [];
}

export function buildWorkflowPromptWarnings(prompt, { availableToolIds, groupSlugs }) {
  const warnings = [];
  const toolIds = collectPromptToolIds(prompt);
  if (toolIds.length > 0) {
    const missing = toolIds.filter((id) => !availableToolIds.has(String(id).trim().toLowerCase()));
    if (missing.length > 0) {
      warnings.push(`This workflow references tools not available in this project: ${missing.join(', ')}`);
    }
  }
  const groupSlug = String(prompt?.ingestion_group_slug || '').trim();
  if (groupSlug && !groupSlugs.has(groupSlug)) {
    warnings.push(`This workflow references ingestion group "${groupSlug}" which is not available in this project.`);
  }
  return warnings;
}
